import React from 'react'
import { Tooltip } from 'antd'
import { FIELD_NAMES } from 'const/forms'
import { Actions, StyledButton } from '../Shops.styles'
import { TruncatedText } from './SeoDescriptionsTab.styles'

const getColumns = (filters, sorter, handleEdit, handleDelete) => [
  {
    title: 'ID',
    dataIndex: FIELD_NAMES.id,
    key: FIELD_NAMES.id,
    width: 80,
  },
  {
    title: 'Title',
    dataIndex: FIELD_NAMES.attributes,
    key: 'title',
    width: 200,
    render: (attributes) => attributes?.title || '-',
  },
  {
    title: 'Description',
    dataIndex: FIELD_NAMES.attributes,
    key: 'description',
    width: 300,
    render: (attributes) => {
      const description = attributes?.description || '-'
      return (
        <Tooltip title={description} placement="topLeft">
          <TruncatedText>{description}</TruncatedText>
        </Tooltip>
      )
    },
  },
  {
    title: 'Image URL',
    dataIndex: FIELD_NAMES.attributes,
    key: 'image_url',
    width: 200,
    ellipsis: true,
    render: (attributes) => attributes?.image_url || '-',
  },
  {
    title: 'Order Value',
    dataIndex: FIELD_NAMES.attributes,
    key: 'order_value',
    width: 120,
    render: (attributes) => attributes?.order_value ?? '-',
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    align: 'center',
    fixed: 'right',
    width: 120,
    render: (_, record) => {
      const onEdit = () => handleEdit(record[FIELD_NAMES.id])
      const onDelete = () => handleDelete(record)
      return (
        <Actions>
          <StyledButton onClick={onEdit}>Edit</StyledButton>
          <StyledButton onClick={onDelete} danger>
            Delete
          </StyledButton>
        </Actions>
      )
    },
  },
]

export default getColumns
